<template>
  <el-table
    :data="blendData"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    class="egl-table all-cash-register-amount-table"
    stripe
    border
  >
    <!-- 売掛金種別 -->
    <el-table-column
      prop="type"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.accountsReceivableType')"
      width="140"
      align="center"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.rowType !== 'total'" :class="[scope.row.rowType === 'subtotal' ? 'sub-total-row' : '' ]">
          {{ accountsReceivableType[scope.row.type] }}
        </div>
        <div v-else>{{ scope.row.type }}</div>
      </template>
    </el-table-column>

    <!-- 売掛金名 -->
    <el-table-column
      prop="name"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.accountReceivableName')"
      width="180"
      align="center"
    >
      <template slot-scope="scope">
        <el-select
          v-if="scope.row.isNewRow"
          class="accountReceivableName"
          :value="tableData[scope.row.type][scope.row.index].name"
          :placeholder="$locale('dailyClosing.createDialog.otherCashPaymentRegistrationTable.selectPlaceHolder')"
          @change="value => changeAction(value, scope.row)"
          :clearable="true"
        >
          <el-option
            v-for="item in receivableList[scope.row.type]"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <template v-else>{{ scope.row.name }}</template>
      </template>
    </el-table-column>

    <!-- レジ理論件数 -->
    <el-table-column
      prop="qty"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.numberOfCashRegisterTheories')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.qty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- レジ実件数 -->
    <el-table-column
      prop="actualQty"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.actualNumberOfRegistrations')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.actualQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- レジ過不足（件数） -->
    <el-table-column
      prop="cashQty"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.excessDeficiencyOfRegistration')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.cashQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- 日次実件数 -->
    <el-table-column
      prop="dayActualQty"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.dayActualQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.rowType === 'subtotal' || scope.row.rowType === 'total'" class="ta-r">
          {{ scope.row.dayActualQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
        <el-input
          v-else
          :value="tableData[scope.row.type][scope.row.index].dayActualQty | separatorFormatter"
          class="ta-r"
          maxlength="10"
          @input="value => inputAction(value, scope.row, 'dayActualQty')"
        ></el-input>
      </template>
    </el-table-column>

    <!-- レジ理論売上 -->
    <el-table-column
      prop="amount"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.registrationTheorySales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.amount | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- レジ実売上 -->
    <el-table-column
      prop="actualAmount"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.actualCashRegisterSales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.actualAmount | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- レジ過不足（売上） -->
    <el-table-column
      prop="cashBalance"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.registrationExcessDeficiencySales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.cashBalance | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- 日次実売上 -->
    <el-table-column
      prop="actualSales"
      :label="$locale('dailyClosing.accountsReceivableTable.allCashRegisterAmountsTableData.th.actualSales')"
      align="center"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.type !== 'settlement' || scope.row.rowType === 'subtotal' || scope.row.rowType === 'total'" class="ta-r">
          {{ scope.row.actualSales | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
        <el-input
          v-else
          :value="tableData[scope.row.type][scope.row.index].actualSales | currencyFormatter"
          class="ta-r"
          maxlength="14"
          @input="value => inputAction(value, scope.row, 'actualSales')"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.control')" width="112" align="center">
      <template slot-scope="scope">
        <div class="handle ctrl" v-if="scope.row.rowType !== 'subtotal' && scope.row.rowType !== 'total'">
          <el-button
            v-if="scope.row.isNewRow"
            class="handle-btn egl-btn-white"
            icon="el-icon-minus"
            @click="removeTableDataAction(scope.row.type, scope.row.index)"
          ></el-button>
          <el-button
            v-if="scope.row.index === tableData[scope.row.type].length - 1"
            class="handle-btn egl-btn-white"
            icon="el-icon-plus"
            @click="addTableDataAction(scope.row.type)"
          ></el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { rounding, digtalParser } from "@/utils/common";
import { ticketDetailResStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "AllCashAmounts",
  props: {
    accountsReceivableType: {
      type: Object,
      default: () => ({}),
    },
    receivableList: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Object,
      default: () => ({
        couponType: [],
        nationalTicket: [],
        settlement: [],
      }),
    },
    isInitData: {
      type: Boolean,
      default: true,
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      if (this.isEmptyData) {
        return [];
      }

      const _tableData = tranfResData(this.tableData);
      const _totalBase = ticketDetailResStruct();
      _totalBase.type = this.$locale("global.total");
      _totalBase.rowType = "total";

      let resultArray = [];

      const _addPropFn = (objArray, type) => {
        const _subTotalBase = ticketDetailResStruct();

        objArray.forEach((_item, i) => {
          // let __price = this.receivableListMappingFn(type, _item.settlementId).price || 0;
          // __price = __price !== 0 ? __price : rounding(_item.amount / _item.qty);
          // _item.price = __price;
          _item.type = type;
          _item.index = i;

          if (i === 0) {
            _item.rowspan = objArray.length + 1;
            _item.colspan = 1;
          } else {
            _item.rowspan = 0;
            _item.colspan = 0;
          }

          for (let __key in _subTotalBase) {
            if (typeof _item[__key] === "number") {
              _subTotalBase[__key] += _item[__key];
              _totalBase[__key] += _item[__key];
            } else if (__key === "name") {
              _subTotalBase[__key] = this.accountsReceivableType[_item.type] + " " + this.$locale("global.total");
            }
          }
        });

        objArray.push({
          ..._subTotalBase,
          rowType: "subtotal",
          type,
        });

        return objArray;
      };

      Object.keys(_tableData).forEach(_key => {
        if (_tableData[_key].length > 0) {
          const _subList = _addPropFn(_tableData[_key], _key);
          resultArray.push(..._subList);
        }
      });

      resultArray.push(_totalBase);

      return resultArray;
    },
    isEmptyData() {
      const _tableData = tranfResData(this.tableData);
      const {
        couponType,
        nationalTicket,
        settlement,
      } = _tableData;

      if (couponType.length === 0 && nationalTicket.length === 0 && settlement.length === 0) {
        return true;
      }

      return false;
    },
  },
  methods: {
    receivableListMappingFn(type, id) {
      if (!this.receivableList[type]) {
        return {};
      }

      const __obj = this.receivableList[type].find(_list => _list.id === id) || {};
      return __obj;
    },
    inputAction(value, row, key) {
      let _value = digtalParser(value);
      const { type, index, price, amount, qty } = row;
      const _price = price !== 0 ? price : rounding(amount / qty);

      if (this.tableData[type][index]) {
        this.tableData[type][index][key] = _value;
        if (key === "dayActualQty") {
          this.tableData[type][index].actualSales = _value * _price;
        }
      }

      this.$emit("update:isInitData", false);
    },
    changeAction(value, row) {
      const { type, index } = row;

      if (this.tableData[type][index]) {
        const { name, price = 0 } = this.receivableListMappingFn(type, value);
        this.tableData[type][index].name = name;
        this.tableData[type][index].price = price;
        this.tableData[type][index].actualSales = this.tableData[type][index].dayActualQty * price;

        if (!this.tableData[type][index].paymentType) {
          delete this.tableData[type][index].paymentType;
        }
      }

      this.$emit("update:isInitData", false);
    },
    spanMethod({ row, columnIndex }) {
      if (row.rowType === "total") {
        if (columnIndex === 0) {
          return [1, 2];

        } else if (columnIndex < 2) {
          return [0, 0];
        }
      }

      if (columnIndex === 0) {
        const { rowspan, colspan } = row;
        return [rowspan, colspan];
      }
    },
    rowClassName({ row }) {
      if (row.rowType === "subtotal") {
        return "sub-total-row";
      } else if (row.rowType === "total") {
        return "total-row";
      }
      return "";
    },
    addTableDataAction(type) {
      const _base = ticketDetailResStruct();
      this.tableData[type].push({
        ..._base,
        isNewRow: true,
      });
    },
    removeTableDataAction(type, index) {
      this.tableData[type].splice(index, 1);
    },
  },
};
</script>
